import { defineComponent, h, PropType } from 'vue';

import { Pie } from 'vue-chartjs';
import { Chart as ChartJS, ArcElement, Plugin } from 'chart.js';
import type { TChartOptions, TChartData } from 'vue-chartjs/dist/types.d';

ChartJS.register(ArcElement);

export default defineComponent({
  name: 'PieChart',
  components: {
    Pie,
  },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    chartId: {
      type: String,
      default: 'pie-chart',
    },
    width: {
      type: Number,
      default: 56,
    },
    height: {
      type: Number,
      default: 56,
    },
    cssClasses: {
      default: '',
      type: String,
    },
    styles: {
      type: Object as PropType<Partial<CSSStyleDeclaration>>,
      default: () => ({
        width: '56px !important',
        height: '56px !important',
      }),
    },
    plugins: {
      type: Array as PropType<Plugin<'pie'>[]>,
      default: () => [],
    },
  },
  setup(props) {
    // const chartData = {
    //   labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
    //   datasets: [
    //     {
    //       backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
    //       data: [40, 20, 80, 10],
    //     },
    //   ],
    // };

    const chartOptions: TChartOptions<'pie'> = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        tooltip: {
          enabled: false,
        },
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
      },
    };

    return () =>
      h(Pie, {
        chartData: props.chartData as TChartData<'pie'>,
        chartOptions,
        chartId: props.chartId,
        width: props.width,
        height: props.height,
        cssClasses: props.cssClasses,
        styles: props.styles,
        plugins: props.plugins,
      });
  },
});
